import React, {Component} from 'react';
import { Tooltip as TippyTooltip } from 'react-tippy';

class Tooltip extends Component {
  render() {
    return (
      <TippyTooltip html={(
        <div className="fs14 tal">
          {this.props.text}
        </div>
      )}
       animateFill={false}
       position="top"
       theme="dark"
      >
        {this.props.children}
      </TippyTooltip>
    )
  }
}


export default Tooltip;